/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: CMSDKCommunicationSurveyMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler = function () {
    com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this, com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SURVEY);
};

$hxClasses.extend(
    com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
    com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler,
    "com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler"
);

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler.prototype.processMessage = function (message) {
    var chatTextKey = com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA;

    var surveyMessage = com.inq.flash.client.chatskins.SkinControl.prepareAsyncSurveyMessage(message.getProperty(chatTextKey));
    message.addProperty(chatTextKey, surveyMessage);
    /** @type {boolean} */
    var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) === "1";
    if (!replay) {
        this.getController().setFlagChatInQueue(false);
        com.inq.flash.client.control.MinimizeManager.lastAgentMessage(surveyMessage);
    }

    this.controller.onNewChatRouterMessage(message);
};

/** @type {com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler} */
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.CMSDKCommunicationSurveyMessageHandler;